import { createFileRoute } from "@tanstack/react-router";
import { CreateAccountForm } from "@/auth/components/createAccountForm";
import logo from "@/assets/EcoPROFIT_Wordmark.png";
import loginImage from "@/assets/login-image.png";

export const Route = createFileRoute("/create-account")({
  component: CreateAccount,
});

function CreateAccount() {
  return (
    <div className="flex h-full w-full grow flex-row">
      <div className="hidden flex-1 overflow-hidden sm:block">
        <img src={loginImage} alt="login" className="h-full w-full object-cover object-center" />
      </div>
      <section className="flex flex-1 items-start justify-center overflow-y-auto">
        <div className="flex w-full max-w-[348px] flex-col items-center gap-4 px-4 pb-4 pt-10 sm:px-0">
          <img src={logo} alt="EcoPROFIT logo" className="h-[48px] w-[202px]" />
          <CreateAccountForm />
        </div>
      </section>
    </div>
  );
}
